<script>
  import { blur } from "svelte/transition";
  import { translate } from "../../translations/index.js";
  const { close } = $props();
</script>

<div class="intro" in:blur={{ duration: 500 }} out:blur={{ duration: 500 }}>

  <h3 class="thanks-title">{translate('thanks.title')}</h3>
  <div class="text">
    <p>
        {translate('thanks.text.one')}
    </p>
  </div>

  <div class="button-wrapper">
    <button class="btn btn-ghost" onclick={() => close(true)} aria-label="Close">
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.99914 8.0598L12.4688 13.5294L13.5294 12.4688L8.0598 6.99914L13.5295 1.52941L12.4689 0.46875L6.99914 5.93848L1.52941 0.46875L0.46875 1.52941L5.93848 6.99914L0.468863 12.4688L1.52952 13.5294L6.99914 8.0598Z"
        />
      </svg>
    </button>
  </div>
</div>

<style>
  .intro {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 32px;

    @media screen and (orientation: landscape) {
      gap: 2vw;
    }
  }

  .thanks-title {
    font-size: 34px;
    font-weight: 500;
    color: var(--color-white);
    text-align: center;
    text-transform: uppercase;
    line-height: 0.9;

    @media screen and (orientation: portrait) and (min-width: 480px) {
      font-size: 48px;
    }

    @media screen and (orientation: portrait) and (min-width: 640px) {
      font-size: 52px;
    }

    @media screen and (orientation: portrait) and (min-width: 960px) {
      font-size: 64px;
    }

    @media screen and (orientation: landscape) and (min-width: 1024px) {
      font-size: 4vw;
    }
  }

  .text {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 32px;
    text-align: center;
    color: var(--color-white);
    line-height: 1.5;
    z-index: 13;
    max-width: 720px;

    @media screen and (orientation: landscape) {
      gap: 2vw;
      max-width: 80vh;
    }
  }

  .button-wrapper {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-top: 16px;

    @media (orientation: landscape) {
    margin-top: 3vw;
      gap: calc(var(--to-vw) * 16);
    }
  }
</style>
